// extracted by mini-css-extract-plugin
export default {"layout":"layout____cd4m"};